import {
  PannellumConfig,
  PannellumViewer,
  PanoramaView,
} from "../models/PanoramicPhoto";

const nodeView: PanoramaView = { yaw: 0, pitch: 0, hfov: 100 };
const modalView: PanoramaView = { yaw: 0, pitch: 0, hfov: 100 };

const savePosition = (viewer: PannellumViewer | null, view: PanoramaView) => {
  if (!viewer) return;
  view.yaw = viewer.getYaw();
  view.pitch = viewer.getPitch();
  view.hfov = viewer.getHfov();
};

const getConfig = (
  baseConfig: PannellumConfig,
  view: PanoramaView,
): PannellumConfig => ({
  ...baseConfig,
  yaw: view.yaw,
  pitch: view.pitch,
  hfov: view.hfov,
});

export const saveNodePosition = (viewer: PannellumViewer | null) =>
  savePosition(viewer, nodeView);
export const saveModalPosition = (viewer: PannellumViewer | null) =>
  savePosition(viewer, modalView);
export const getNodeConfig = (base: PannellumConfig) =>
  getConfig(base, nodeView);
export const getModalConfig = (base: PannellumConfig) =>
  getConfig(base, modalView);
